(() => {
  'use strict';
  if (customElements.get('product-variant-picker')) return;
  customElements.define('product-variant-picker', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-variant-form]');
      this.select = this.querySelector('[data-product-variant-select]');
      if (!this.form || !this.select) return;
      this.controller = new AbortController();
      this.querySelector('[data-variant-apply]').hidden = true;
      this.select.addEventListener('change', () => {
        // A full product render keeps media, inventory, plans and shipping in sync.
        const url = new URL(this.form.action);
        const current = new URL(window.location.href);
        url.search = current.search;
        url.searchParams.set('variant', this.select.value);
        url.searchParams.delete('selling_plan');
        window.location.assign(url.href);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.native-product-form [name="selling_plan"]')) return;
    const summary = event.target.closest('form').querySelector('[data-product-plan-summary]');
    if (summary) summary.textContent = event.target.selectedOptions[0]?.textContent || '';
  });
})();
